import { useTranslation } from "react-i18next";
import { useGetFaqByCategoryQuery } from "../../../api/network/helpApiServices";
import svgIcons from "../../../assets/svg/svgIcons";

export default function HelpFaq() {
  const { t } = useTranslation("translation", { keyPrefix: "helpSection" });
  const {
    data: dataFaqByCategory,
    isFetching: isFetchingFaqByCategory,
  } = useGetFaqByCategoryQuery("Help"); // "Help" because that's the category we're using

  return (
    <section className="w-full px-10 py-12 items-space-between">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-8 items-start">
          <div className="space-y-5">
            <h2 className="text-2xl font-semibold mb-8 text-black">
              Frequently Asked Questions
            </h2>

            {isFetchingFaqByCategory ? (
              <div className={`relative z-10 w-full h-48`}>
                <img src={svgIcons.LoadingAnimation} alt="loading-animation" className="size-16 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
              </div>
            ) : (
              dataFaqByCategory ? (
                dataFaqByCategory?.results.map(faq => (
                  <div
                    key={faq.id}
                    className="bg-white border border-gray-200 rounded-xl px-6 py-5"
                  >
                    <h3 className="text-lg font-semibold mb-1 text-gray-800">
                      {faq.question}
                    </h3>

                    <p className="text-sm leading-6 text-gray-500">
                      {faq.answer}
                    </p>
                  </div>
                )
                )) : (
                <div className="p-4 text-gray-500 flex items-center justify-center">{t("no_results_found")}</div>
              )
            )}
          </div>

          <div className="space-y-6">
            <div className="bg-accent-blue-verydark rounded-xl p-6 text-white" >
              <h3 className="text-base font-semibold mb-3">
                Need More Help?
              </h3>
              <p className="text-sm leading-6 text-blue-100">
                Our team is available 24/7 for tailored technical support and
                complex solution architecture. Call our Technical Services Team at{" "}
                <span className="font-semibold text-white">
                  844-291-7514
                </span>
                . We're here to help!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}